
import React from 'react';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';

interface SubmitButtonProps {
  isLoading: boolean;
  isSubmitting?: boolean; // Add isSubmitting as an alias for isLoading
  text?: string;
  loadingText?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  isLoading,
  isSubmitting, // Accept isSubmitting as an alias
  text = "Create Account",
  loadingText = "Creating Account...",
  icon = <UserPlus className="mr-2 h-4 w-4" />,
  disabled = false
}) => {
  // Use either isLoading or isSubmitting 
  const isButtonLoading = isLoading || isSubmitting || false;
  
  return (
    <Button 
      type="submit" 
      className="w-full"
      disabled={isButtonLoading || disabled}
    >
      {isButtonLoading ? (
        <span className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {loadingText}
        </span>
      ) : (
        <span className="flex items-center justify-center">
          {icon}
          {text}
        </span>
      )}
    </Button>
  );
};
